var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "he-row",
    { class: _vm.getClass("row-affect-cmd-item ml-0 px-3", " separator-top") },
    [
      _c(
        "he-column",
        [
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("BesoinTransfoId")
                    },
                    domProps: { value: _vm.besoinId }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("numPoste")
                    },
                    domProps: { value: _vm.numPoste }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("nomPoste")
                    },
                    domProps: { value: _vm.nomPoste }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("type")
                    },
                    domProps: { value: _vm.type }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: _vm.getPrefixedName("tpc") },
                    domProps: { value: _vm.tpc }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("puissance")
                    },
                    domProps: { value: _vm.puissance }
                  }),
                  _vm._v(" "),
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "Type Transformateur :",
                      defaultValue: _vm.type
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: { label: "Puissance :", defaultValue: _vm.puissance }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "TPC :",
                      defaultValue: _vm.tpc == true ? "Oui" : "Non"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isCommande
            ? _c(
                "he-row",
                [
                  _c(
                    "he-column",
                    [
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          name: _vm.getPrefixedName("idEntreprise")
                        },
                        domProps: { value: _vm.entrepriseId }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-inline-block mr-2" }, [
                        _vm._v(
                          "\n                    Seulement les Transformateurs de l'entreprise du Bon de commande unique :\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("check-box", {
                        ref: "chkbfilter",
                        staticClass: "d-inline-block",
                        attrs: {
                          name: _vm.getPrefixedName("filter"),
                          label: " ",
                          selected: _vm.filter,
                          inline: "true"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCommande
            ? _c(
                "he-row",
                [
                  _c(
                    "he-column",
                    [
                      _c("select-custom", {
                        ref: "select",
                        attrs: {
                          type: "4",
                          parameters: _vm.getParameters(),
                          parametersTemplate: "type,puissance,tpc,idEntreprise",
                          name: _vm.getPrefixedName("gestionTransfoId"),
                          label: "Transformateurs disponibles :",
                          required: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("span", { staticClass: "d-inline-block mr-2" }, [
                    _vm._v(
                      "\n                    Effectuer une commande :\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("check-box", {
                    ref: "chkbcmd",
                    staticClass: "d-inline-block",
                    attrs: {
                      name: _vm.getPrefixedName("isCommande"),
                      label: " ",
                      selected: _vm.isCommande,
                      inline: "true"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7582b0c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7582b0c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/AffectationTransformateur.vue
// module id = 575
// module chunks = 0